import { render } from "./SideBarVue.vue?vue&type=template&id=44e06540&lang=pug"
import script from "./SideBarVue.vue?vue&type=script&lang=js"
export * from "./SideBarVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__